import React from 'react';

import clsx from 'clsx';

import * as classes from './StatementBlock.module.css';

const StatementBlock = ({
    innerEditor,
    parentId,
    id,
    value,
    ...props
}) => {

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`${id}-statement-block`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div
                data-parentId={parentId}
                data-id={id}
                id={`${id}-statement-block`}
                className={classes.StatementBlock}
            >
                <div className={classes.StatementContainer}>
                    <div className={classes.LabelContainer}>
                        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className={classes.Label}>Control</label>
                        { /* eslint-disable-next-line jsx-a11y/no-onchange */}
                        <select data-select-id={id} defaultValue={value} className={classes.Select}>
                            <option>And</option>
                            <option>Or</option>
                            <option>Not</option>
                            <option>True</option>
                            <option>False</option>
                            <option>Null</option>
                        </select>
                    </div>
                </div>
                <span
                    id={`${id}-delete`}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default StatementBlock;
